module.exports = __webpack_public_path__ + "static/media/ENVIRONMENT - 5025 C.d4a75f9f.jpg";